import { render, staticRenderFns } from "./PaymentPayonex.vue?vue&type=template&id=96a114a8&scoped=true&"
import script from "./PaymentPayonex.vue?vue&type=script&lang=js&"
export * from "./PaymentPayonex.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPayonex.vue?vue&type=style&index=0&id=96a114a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a114a8",
  null
  
)

export default component.exports